import * as React from 'react';
import cn from 'classnames';
import { HTMLAttributes } from 'react';
import '@mos-utils/css/lib/typography/Paragraph.css';

function Paragraph({ tag = 'p', className = '', children, ...props }: Props) {
  return React.createElement(
    tag,
    {
      className: cn('mos-text', className),
      ...props
    },
    children
  );
}

interface Props<T = HTMLParagraphElement> extends HTMLAttributes<T> {
  /**
   * Тэг для отображения
   */
  tag?: string;
}

Paragraph.defaultProps = {
  tag: 'p'
};

export default Paragraph;
